export const BADGE_STATUSES = {
    LOCKED: 'locked',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
} as const;

export type BadgeStatus = (typeof BADGE_STATUSES)[keyof typeof BADGE_STATUSES];
